<template>
  <span class="ui-icon-base component" v-on="$listeners">
    <component :is="iconName" :width="width" :height="height" :color="color"> </component>
  </span>
</template>

<script>
import write from './write'
import moon from './moon'
import done from './done'
import arrowDown from './arrowDown'
import sort from './sort'
import sortDown from './sortDown'
import sortUp from './sortUp'
import mail from './mail'
import dashBoard from './dashBoard'
import pie from './pie'
import monitor from './monitor'
import report from './report'
import fill from './fill'
import calendar from './calendar'
import tick from './tick'
import refresh from './refresh'
import product from './product'
import seller from './seller'
import outlet from './outlet'
import payment from './payment'
import register from './register'
import cashier from './cashier'
import sell_report from './sell_report'
import revenue from './revenue'
import orders from './orders'
import products from './products'
import tax from './tax'
import global from './global'
import chevron_left from './chevronLeft'
import chevron_right from './chevronRight'
import left_from_line from './leftFromLine.vue'
import right_from_line from './rightFromLine.vue'
import close from './close.vue'

export default {
  name: 'UiIconBase',
  props: {
    iconName: {
      type: String,
      default: 'moon'
    },
    width: {
      type: String,
      default: '18px'
    },
    height: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  },

  components: {
    write,
    moon,
    done,
    arrowDown,
    sort,
    sortDown,
    sortUp,
    mail,
    dashBoard,
    pie,
    monitor,
    report,
    fill,
    calendar,
    tick,
    refresh,
    product,
    seller,
    outlet,
    payment,
    register,
    cashier,
    sell_report,
    revenue,
    orders,
    products,
    tax,
    global,
    chevron_left,
    chevron_right,
    left_from_line,
    right_from_line,
    close
  }
}
</script>

<style lang="scss" scoped>
.ui-icon-base.component {
  display: inline-block;
}
</style>
